import React from 'react'

export const InPersonFilled = ({
  width = 20,
  height = 20,
  fill = '#282828'
}: {
  width?: number
  height?: number
  fill?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <path
        d="M17.5 8.33341C16.5833 8.33341 15.8333 9.08341 15.8333 10.0001V12.5001H4.16665V10.0001C4.16665 9.08341 3.42498 8.33341 2.49998 8.33341C1.57498 8.33341 0.833313 9.08341 0.833313 10.0001V14.1667C0.833313 15.0834 1.58331 15.8334 2.49998 15.8334H17.5C18.4166 15.8334 19.1666 15.0834 19.1666 14.1667V10.0001C19.1666 9.08341 18.4166 8.33341 17.5 8.33341ZM15 4.16675H4.99998C4.08331 4.16675 3.33331 4.91675 3.33331 5.83341V7.62508C4.29998 7.96675 4.99998 8.89175 4.99998 9.96675V11.6667H15V9.97508C15 8.89175 15.7 7.97508 16.6666 7.63341V5.83341C16.6666 4.91675 15.9166 4.16675 15 4.16675Z"
        fill="#282828"
      />
    </svg>
  )
}
